export const userFilterOption = [
  { value: "Search By", label: "Search By", diasbled: true },
  { value: "name", label: "By Name" },
  { value: "email", label: "By Email" },
];

export const OrganizarionFilter = [
  { value: "Search By", label: "Search By", diasbled: true },
  { value: "name", label: "Organization Name" },
  { value: "email", label: "Organization Email" },
  { value: "domain", label: "Organization Domain" },
  { value: "contact_no", label: "Organization Contact" },
  { value: "country", label: "Country" },
];

export const ContestFilter = [
  { value: "title", label: "Assessment Title" },
  { value: "organization", label: "Organization Name" },
  { value: "test_code", label: "Test Code" },
];

export const requestFilter = [
  { value: "Search By", label: "Search By", diasbled: true },
  { value: "name", label: "Reported By" },
  { value: "email", label: "Reporter's Email" },
];

export const demoFilter = [
  { value: "Search By", label: "Search By", diasbled: true },
  { value: "name", label: "Reported By" },
  { value: "email", label: "Reporter's Email" },
];
